import { Flex } from "@radix-ui/themes";
import type { ObservationPoint, SeriesInfo, Unit } from "@/types";
import { SeriesSelect } from "./SeriesSelect";
import { DateRangeInputs } from "./DateRangeInputs";
import { CurrentValueReadout } from "./CurrentValueReadout";

interface ControlStripProps {
  series: SeriesInfo[];
  seriesId: string;
  onSeriesChange: (seriesId: string) => void;
  from: string;
  to: string;
  onApplyRange: (from: string, to: string) => void;
  readoutStatus: "loading" | "ready" | "empty" | "error";
  latestPoint: ObservationPoint | null;
  unit: Unit | null;
  unitVars?: Record<string, string>;
}

export function ControlStrip({
  series,
  seriesId,
  onSeriesChange,
  from,
  to,
  onApplyRange,
  readoutStatus,
  latestPoint,
  unit,
  unitVars,
}: ControlStripProps) {
  return (
    <Flex
      className="rk-control-strip"
      align={{ initial: "stretch", md: "end" }}
      justify="between"
      direction={{ initial: "column", md: "row" }}
      gap="4"
      wrap="wrap"
    >
      <Flex align="end" gap="4" wrap="wrap" className="rk-control-strip-inputs">
        <div className="rk-field">
          <SeriesSelect series={series} value={seriesId} onChange={onSeriesChange} />
        </div>
        <DateRangeInputs from={from} to={to} onApply={onApplyRange} />
      </Flex>
      <CurrentValueReadout status={readoutStatus} latestPoint={latestPoint} unit={unit} unitVars={unitVars} />
    </Flex>
  );
}
